export const TABLE_CONTEXT_SUFFIX = '-table';
export const TIME_SERIES_CONTEXT_SUFFIX = '-time-series';
export const TILE_CONTEXT_SUFFIX = '-tile';
export const WIDGETS_CONTEXT_SUFFIX = '-widgets';
